<template>
  <div class="product-w">
    <img class="top-img" src="../../assets/img/product/product-t.png" alt="">
    <div class="product-tabs">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="X射线安检机" name="first">
          <div class="anjianji" v-show="list">
            <div class="anjianji-i" v-for="(i,k) in ji" :key="k" @click="goDetails(i)">
              <div class="iimg-w">
                <img class="iimg1" :src="i.img" alt="">
              </div>
              <div class="ji-r">
                <div class="jir-t">{{i.title}}</div>
                <div class="jir-c">{{i.tedian}}</div>
              </div>
            </div>
          </div>
          <div v-show="!list">
            <div class="detail-w">
              <div class="img-w">
                <img class="detail-img" :src="xq.img" alt="">
              </div>
              <div class="detail-r">
                <div class="detail-t">{{xq.title}}</div>
                <div class="detail-c">{{xq.tedian}}</div>
              </div>
              <!-- <div class="img-w2">
                <img class="detail-img" :src="xq.baseimg" alt="">
              </div> -->
            </div>
            <div class="goback" @click="golist"></div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="安检门" name="second">
          <div class="anjianji"  v-show="list">
            <div class="anjianji-i" v-for="(i,k) in door" :key="k" @click="goDetails(i)">
              <div class="iimg-w">
                <img class="iimg2" :src="i.img" alt="">
              </div>
              <div class="ji-r">
                <div class="jir-t">{{i.title}}</div>
                <div class="jir-c">{{i.tedian}}</div>
              </div>
            </div>
          </div>
          <div v-show="!list">
            <div class="detail-w">
              <div class="img-w">
                <img class="detail-img1" :src="xq.img" alt="">
              </div>
              <div class="detail-r">
                <div class="detail-t">{{xq.title}}</div>
                <div class="detail-c">{{xq.tedian}}</div>
              </div>
            </div>
            <div class="goback" @click="golist"></div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="液态安全检验仪器" name="thrid">
          <div class="anjianji" v-show="list">
            <div class="anjianji-i" v-for="(i,k) in yetai" :key="k" @click="goDetails(i)">
              <div class="iimg-w">
                <img class="iimg" :src="i.img" alt="">
              </div>
              <div class="ji-r">
                <div class="jir-t">{{i.title}}</div>
                <div class="jir-c">{{i.tedian}}</div>
              </div>
            </div>
          </div>
          <div v-show="!list">
            <div class="detail-w">
              <div class="img-w">
                <img class="detail-img" :src="xq.img" alt="">
              </div>
              <div class="detail-r">
                <div class="detail-t">{{xq.title}}</div>
                <div class="detail-c">{{xq.tedian}}</div>
              </div>
            </div>
            <div class="goback" @click="golist"></div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="便携式爆炸物/毒品探测仪" name="fourth">
          <div class="anjianji" v-show="list">
            <div class="anjianji-i" v-for="(i,k) in bianxie" :key="k" @click="goDetails(i)">
              <div class="iimg-w">
                <img class="iimg" :src="i.img" alt="">
              </div>
              <div class="ji-r">
                <div class="jir-t">{{i.title}}</div>
                <div class="jir-c">{{i.tedian}}</div>
              </div>
            </div>
          </div>
          <div v-show="!list">
            <div class="detail-w">
              <div class="img-w">
                <img class="detail-img" :src="xq.img" alt="">
              </div>
              <div class="detail-r">
                <div class="detail-t">{{xq.title}}</div>
                <div class="detail-c">{{xq.tedian}}</div>
              </div>
            </div>
            <div class="goback" @click="golist"></div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="开包复检台" name="sixth">
          <div class="anjianji" v-show="list">
            <div class="anjianji-i" v-for="(i,k) in fujiantai" :key="k" @click="goDetails(i)">
              <div class="iimg-w">
                <img class="iimg" :src="i.img" alt="">
              </div>
              <div class="ji-r">
                <div class="jir-t">{{i.title}}</div>
                <div class="jir-c">{{i.tedian}}</div>
              </div>
            </div>
          </div>
          <div v-show="!list">
            <div class="detail-w">
              <div class="img-w">
                <img class="detail-img" :src="xq.img" alt="">
              </div>
              <div class="detail-r">
                <div class="detail-t">{{xq.title}}</div>
                <div class="detail-c">{{xq.tedian}}</div>
              </div>
            </div>
            <div class="goback" @click="golist"></div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="专属恒安辅料定制" name="fifth">
          <div class="anjianji" v-show="list">
            <div class="anjianji-i" v-for="(i,k) in fuliao" :key="k" @click="goDetails(i)">
              <div class="iimg-w">
                <img class="iimg" :src="i.img" alt="">
              </div>
              <div class="ji-r">
                <div class="jir-t">{{i.title}}</div>
                <div class="jir-c">{{i.tedian}}</div>
              </div>
            </div>
          </div>
          <div v-show="!list">
            <div class="detail-w">
              <div class="img-w">
                <img class="detail-img" :src="xq.img" alt="">
              </div>
              <div class="detail-r">
                <div class="detail-t">{{xq.title}}</div>
                <div class="detail-c">{{xq.tedian}}</div>
              </div>
            </div>
            <div class="goback" @click="golist"></div>
          </div>
        </el-tab-pane>
        <!-- <el-tab-pane v-for="i in tabs" :key="i.ID" :label="i.Product_title" :name="(i.ID).toString()">
          <div class="anjianji" v-show="list">
            <div class="anjianji-i" v-for="(i,k) in lists" :key="k" @click="goDetails(i)">
              <div class="iimg-w">
                <img class="iimg1" :src="i.Product_Img" alt="">
              </div>
              <div class="ji-r">
                <div class="jir-t">{{i.Product_title}}</div>
                <div class="jir-c" v-html="i.Product_details"></div>
              </div>
            </div>
          </div>
          <div v-show="!list">
            <div class="detail-w">
              <div class="img-w">
                <img class="detail-img" :src="xq.Product_Img" alt="">
              </div>
              <div class="detail-r">
                <div class="detail-t">{{xq.Product_title}}</div>
                <div class="detail-c" v-html="xq.Product_details"></div>
              </div>
            </div>
            <div class="goback" @click="golist"></div>
          </div>
        </el-tab-pane> -->
      </el-tabs>
    </div>
  </div>
</template>
<script>
import {axios} from '../../serve/index'
export default {
  name: 'product',
  data () {
    return {
      // activeName: '',
      activeName: 'first',
      list: true,
      xq: '',
      ji: [
        {
          img: require('../../assets/img/product/HA-6550.png'),
          // baseimg: require('../../assets/img/product/HA-6550base.png'),
          title: 'HA-6550',
          tedian: '图像更清晰；极低的泄漏射线剂量率；一键关机功能；模块化设计使故障诊断、维修更加准确快捷；爆炸物毒品辅助探测功能；图像放大操作更方便、更高效；支持专用图像格式转换；模块化设计使故障诊断、维修更加准确快捷；根据人体工程学设计交互界面'
        },
        {
          img: require('../../assets/img/product/HA-6550D.png'),
          title: 'HA-6550D',
          tedian: '可选配报警功能，当样机辐射剂量超标时可发出报警信息;可选配联网功能，可通过远程客户端启动和停止样机;可选配摄像功能，可通过摄像机实时拍摄现场图像;超薄物体检测能，检测出超薄物体;一键关机控制，节能设计;'
        },
        {
          img: require('../../assets/img/product/HA-100100.png'),
          title: 'HA-100100',
          tedian: '一键关机控制，节能设计;可选配报警功能，当样机辐射剂量超标时可发出报警信息;可选配联网功能，可通过远程客户端启动和停止样机;可选配摄像功能，可通过摄像机实时拍摄现场图像;超薄物体检测能，检测出超薄物体'
        },
        {
          img: require('../../assets/img/product/HA-100100D.png'),
          // baseimg: require('../../assets/img/product/HA-100100Dbase.png'),
          title: 'HA-100100D',
          tedian: '一键关机控制，节能设计;可选配报警功能，当样机辐射剂量超标时可发出报警信息;可选配联网功能，可通过远程客户端启动和停止样机;可选配摄像功能，可通过摄像机实时拍摄现场图像;超薄物体检测能，检测出超薄物体'
        },
        {
          img: require('../../assets/img/product/HA-100100.png'),
          title: 'HA-10080',
          tedian: '超薄物体检测能，检测出超薄物体;一键关机控制，节能设计;可选配报警功能，当样机辐射剂量超标时可发出报警信息;可选配联网功能，可通过远程客户端启动和停止样机;可选配摄像功能，可通过摄像机实时拍摄现场图像;'
        }
      ],
      door: [
        {
          img: require('../../assets/img/product/WS-100S.png'),
          title: 'WS-100S',
          tedian: '金属探测安检门采用世界先进的电磁兼容设计和抗震动设计，具有极强的抗干扰能力和抗震能力，适用于管制刀具和枪支等危险物品的安全检查，广泛应用于监狱、法院、工厂、客运站、中展览会馆、会议中心、大型运动会、演唱会等重要场所。超高灵敏度，可检测到半个 回型针大小的金属，且灵敏度可根据需要调节。内置自我诊断程序，开机自检，具有起强的抗干扰能力。产品具有自动计数功能，可统计通过人数与报售次数，精确率100%。'
        },
        {
          img: require('../../assets/img/product/WS-100W.png'),
          title: 'WS-100W',
          tedian: '智慧通行安检门，是一款兼具多维功能如违禁物品探测、易燃易爆气体分子检测、人证比对核验、动态人脸抓拍、热成像体温筛查、黑名单人脸比对分析、本地边缘计算和大屏显示、云端大数据平台、本地边缘计算能力和联网能力、具有本地可视化呈现和云平台数据汇聚分析功能的最新一代智慧型通行安检系统。'
        }
      ],
      yetai: [
        {
          img: require('../../assets/img/product/WS-8001.png'),
          title: 'WS-8001',
          tedian: '采用超宽带脉冲微波反射法及热导法，无辐射设置对人体及被检物品均无害，检测方法环保、安全。'
        }
      ],
      bianxie: [
        {
          img: require('../../assets/img/product/WS-9001.png'),
          title: 'WS-9001',
          tedian: '全球首创的不含放射性源，使用安全、方便，能准确分析出毒品成分。'
        }
      ],
      fujiantai: [
        {
          img: require('../../assets/img/product/fujiantai.png'),
          title: '开包复检台',
          tedian: '违禁品、照片、身份证、电话及报警记录信息多维融合与关联，数据结人包图、音视频、构化存储，可上传信息化平台可上传上级中心，可查可取可追溯，实现安检事件全纪录与安检事件闭环。支持用户权限、信息管理和支持安检人员WEB考勤管理。支持账户密码、工号及指纹等多样化登录方式。满足不同安检点安检出入口登记需求，根据场景灵活配置。'
        }
      ],
      fuliao: [
        {
          img: require('../../assets/img/product/fuliao1.jpg'),
          title: '物料1',
          tedian: '专属恒安辅料定制'
        },
        {
          img: require('../../assets/img/product/fuliao2.png'),
          title: '物料2',
          tedian: '专属恒安辅料定制'
        },
        {
          img: require('../../assets/img/product/fuliao3.png'),
          title: '物料3',
          tedian: '专属恒安辅料定制'
        }
      ],
      tabs: [],
      lists: []
    }
  },
  mounted () {
    // this.getTabs()
  },
  methods: {
    getTabs () {
      // axios.get('http://192.168.11.220/api/Backstage_Producte/ListBackstage_Product')
      axios.get('api/Backstage_Producte/selectBackstage_ProductList')
        .then(res => {
          this.tabs = res.data.data.datas
          this.activeName = this.tabs[0].ID.toString()
          this.getList(this.activeName)
        })
    },
    getList (id) {
      // axios.get('http://192.168.11.220/api/Backstage_Producte_details/SelectProducte_detailsList?Id=' + id)
      axios.get('api/Backstage_Producte_details/SelectProducte_detailsList?Id=' + id)
        .then(res => {
          this.lists = res.data.data.datas
        })
    },
    handleClick (tab, event) {
      this.list = true
      this.getList(this.activeName)
    },
    goDetails (t) {
      this.list = false
      this.xq = t
    },
    golist () {
      this.list = true
    }
  }
}
</script>
<style scoped>
.top-img{
  width: 100%;
  height: 400px;
}
.product-tabs{
  width: 1200px;
  margin: 20px auto 100px;
}
.anjianji{
  width: 100%;
  display: flex;
  padding-top: 50px;
  flex-wrap: wrap;
  justify-content: space-between;
}
.anjianji-i{
  width: 575px;
  height: 200px;
  margin-bottom: 50px;
  border: 1px solid #ddd;
  cursor:pointer;
}
.iimg-w{
  /* width: 240px; */
  width: 42%;
  height: 200px;
  border-right: 1px solid #ddd;
  display: inline-block;
  overflow: hidden;
}
.iimg{
  width: 100%;
  height: 99%;
}
.iimg1{
  width: 100%;
  height: auto;
}
.iimg2{
  width: auto;
  height: 99%;
}
.ji-r{
  /* width: 332px; */
  width: 57.7%;
  height: 200px;
  float: right;
}
.jir-t{
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #333333;
  margin: 40px 15px 19px;
}
.jir-c{
  width: 300px;
  height: 95px;
  font-size: 12px;
  font-family: Microsoft YaHei UI;
  font-weight: 400;
  color: #999999;
  line-height: 20px;
  margin-left: 15px;
  display:-webkit-box;
  -webkit-box-orient:vertical;
  -webkit-line-clamp:5;
  overflow:hidden;
}
.detail-w{
  width: 100%;
  padding-top: 80px;
}
.img-w{
  width: 600px;
  height: 500px;
  display: inline-block;
}
.img-w2{
  width: 723px;
  display: inline-block;
}
.detail-img{
  width: 100%;
  height: auto;
}
.detail-img1{
  width: auto;
  height: 100%;
}
.detail-r{
  width: 558px;
  min-height: 500px;
  float: right;
}
.detail-t{
  font-size: 30px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #333333;
  line-height: 50px;
  margin-bottom: 48px;
}
.detail-c{
  width: 463px;
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #333333;
  line-height: 40px;
}
.goback{
  float: right;
  width: 120px;
  height: 40px;
  background: url('../../assets/img/tech/btn-4.png');
  background-size: 100%;
  margin: 60px 0 0 1080px;
}
.goback:hover{
  background: url('../../assets/img/tech/btn-3.png');
  background-size: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/view/product.vue